import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 6L8 10L12 6", style: {
  fill: "none"
}, stroke: "currentColor", strokeWidth: 1.33, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgChevronDown;
